import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function ContattoValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const rawValue = control.value || '';
  const value = rawValue.trim();

  const parent = control.parent;
  const validation = parent?.get('type')?.value?.validation;
  const regex = validation?.regex ? new RegExp(validation.regex) : null;
  const type = validation?.type ?? 'contatto';

  if (!value) return null;

  if (type === 'email') {
    // fallback su Validators.email ma con valore normalizzato
    return Validators.email({ ...control, value } as any) === null
      ? null
      : { email: true };
  }

  return regex && regex.test(value) ? null : { [type]: true };
}
